var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.4,
    height: 58.025,
    viewBox: "0 0 57.4 58.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-clockwise-circular-arrow",
    "data-name": "002-clockwise-circular-arrow",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 0, 34.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M2.6,28.936a2.6,2.6,0,0,1,2.6,2.6v4.182A20.076,20.076,0,1,1,3.1,50.438a2.6,2.6,0,1,1,5.063-1.218A14.859,14.859,0,0,0,22.627,60.6,14.876,14.876,0,1,0,9.457,38.8h2.878a2.6,2.6,0,0,1,0,5.208H2.6A2.6,2.6,0,0,1,0,41.4V31.539A2.6,2.6,0,0,1,2.6,28.936Z",
    transform: "translate(0 -25.641)",
    fill: "#00868e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.5cc1a9ad43a35081b43293d6971bdcaf.svg";
export { ForwardRef as ReactComponent };